// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";

var Js_ = {};

function fromJs(js) {
  return {
          closed: js.closed,
          unsubscribe: (function (param) {
              js.unsubscribe();
            })
        };
}

var Subscription = {
  Js_: Js_,
  fromJs: fromJs
};

var Js_$1 = {};

var Observer = {
  Js_: Js_$1
};

var Js_$2 = {};

function fromJs$1(t) {
  return {
          subscribe: (function (onNext, onError, onComplete, param) {
              return fromJs(t.subscribe(onNext, onError !== undefined ? Caml_option.valFromOption(onError) : undefined, onComplete !== undefined ? Caml_option.valFromOption(onComplete) : undefined));
            })
        };
}

var Observable = {
  Js_: Js_$2,
  fromJs: fromJs$1
};

export {
  Subscription ,
  Observer ,
  Observable ,
}
/* No side effect */
